import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="secondary-nav-mobile"
// Automatically scrolls the active navigation item into view on mobile
export default class extends Controller {
  connect() {
    // Small delay to ensure DOM is fully rendered and layout is complete
    setTimeout(() => {
      // Find the active nav item
      const activeItem = this.element.querySelector('.secondary-nav-mobile-item.active')

      if (activeItem) {
        // Calculate scroll position to center the active item
        const container = this.element
        const itemLeft = activeItem.offsetLeft
        const itemWidth = activeItem.offsetWidth
        const containerWidth = container.offsetWidth

        // Calculate scroll position to center the item
        const scrollPosition = itemLeft - (containerWidth / 2) + (itemWidth / 2)

        // Scroll the container horizontally
        container.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        })
      }
    }, 100) // 100ms delay to ensure rendering is complete
  }
}
